"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createCompare = exports.createLargerEq = exports.createLarger = exports.createSmallerEq = exports.createSmaller = exports.createUnequal = exports.createEqual = void 0;
var mathjs_1 = require("mathjs");
exports.createEqual = mathjs_1.factory('equal', [], function () {
    return function equal(a, b) {
        return a === b;
    };
});
exports.createUnequal = mathjs_1.factory('unequal', [], function () {
    return function unequal(a, b) {
        return a !== b;
    };
});
exports.createSmaller = mathjs_1.factory('smaller', [], function () {
    return function smaller(a, b) {
        return a < b;
    };
});
exports.createSmallerEq = mathjs_1.factory('smallerEq', [], function () {
    return function smallerEq(a, b) {
        return a <= b;
    };
});
exports.createLarger = mathjs_1.factory('larger', [], function () {
    return function larger(a, b) {
        return a > b;
    };
});
exports.createLargerEq = mathjs_1.factory('largerEq', [], function () {
    return function largerEq(a, b) {
        return a >= b;
    };
});
exports.createCompare = mathjs_1.factory('compare', [], function () {
    return function compare(a, b) {
        return a > b ? 1 : a < b ? -1 : 0;
    };
});
//# sourceMappingURL=comparator.js.map